import { InboundTollingAgreementSortOption } from '@rematter/frontend-lib-api-client';

import { InboundTollingAgreementRecord } from '../types/inboundTollingAgreement';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const inboundTollingAgreementsQueryAtom = createQueryAtomFactory(
  'production.inboundTollingAgreements',
  (params: {
    searchTerm?: string;
    processingTypeIds?: string[];
    customerAccountIds?: string[];
    isActive?: boolean;
    limit?: number;
    offset?: number;
    sorting?: InboundTollingAgreementSortOption[];
  }) => ({
    inboundTollingAgreements: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          processingTypeIds: params.processingTypeIds,
          customerAccountIds: params.customerAccountIds,
          isActive: params.isActive,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 25,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        agreementNumber: true,
        customerAccountId: true,
        customerAccount: {
          id: true,
          name: true,
        },
        processingTypeId: true,
        processingType: {
          id: true,
          name: true,
        },
        effectiveDate: true,
        expirationDate: true,
        pricePerUnit: {
          amount: true,
          currencyCode: true,
        },
        priceUnit: true,
        expectedYieldPercentage: true,
        terms: true,
        isActive: true,
        invoicePricingBasis: true,
        facility: {
          id: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (
      data,
    ): {
      inboundTollingAgreements: InboundTollingAgreementRecord[];
      totalCount: number;
    } => {
      if (!data?.inboundTollingAgreements?.entries) {
        return {
          inboundTollingAgreements: [],
          totalCount: 0,
        };
      }

      return {
        inboundTollingAgreements: data.inboundTollingAgreements.entries.map(
          (tpa) => ({
            id: tpa.id,
            agreementNumber: tpa.agreementNumber,
            customerAccountId: tpa.customerAccountId,
            customerAccountName: tpa.customerAccount?.name,
            processingTypeId: tpa.processingTypeId,
            processingTypeName: tpa.processingType?.name,
            effectiveDate: tpa.effectiveDate,
            expirationDate: tpa.expirationDate ?? undefined,
            pricePerUnitAmount: tpa.pricePerUnit?.amount
              ? Number(tpa.pricePerUnit.amount)
              : undefined,
            pricePerUnitCurrency: tpa.pricePerUnit?.currencyCode,
            priceUnit: tpa.priceUnit ?? undefined,
            expectedYieldPercentage: tpa.expectedYieldPercentage
              ? Number(tpa.expectedYieldPercentage)
              : undefined,
            terms: tpa.terms ?? undefined,
            isActive: tpa.isActive,
            invoicePricingBasis: tpa.invoicePricingBasis,
            facilityId: tpa.facility.id,
            createdAt: tpa.timestamps.createdAt,
            updatedAt: tpa.timestamps.updatedAt,
          }),
        ),
        totalCount: data.inboundTollingAgreements.page?.total ?? 0,
      };
    },
  },
);
